import { render } from "./TheC01ItemDetail.vue?vue&type=template&id=e086995e&scoped=true&ts=true"
import script from "./TheC01ItemDetail.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemDetail.vue?vue&type=script&lang=ts"

import "./TheC01ItemDetail.vue?vue&type=style&index=0&id=e086995e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e086995e"]])

export default __exports__